/* eslint-disable import/default */
/* eslint-disable import/namespace */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getTransport } from "../../transport";
import {
  localAudioTrackUnMute,
  localVideoTrackMute,
  localVideoTrackUnMute,
  startscreenshare,
  stopscreenshare,
  GetRoom,
  getAudioTracks,
} from "./index";
import {
  requestCallParticipiantsVideos,
  setGalleryTracks,
  requestPinParticipiantVideos,
  ShowActiveSpeakerOnFirstPage,
  muteMic,
  calculateBounds,
  getAudioElement,
} from "../CallCommon";
import { setDesktopScreenShareShow, setIsActivePenDraw } from "./libSlice";
import {
  setAddPeoplePopUp,
  setRecordingConsentUserIds,
  setSharedFileData,
} from "../../redux/callSlice";
import store from "../../../store";
import AddPeople from "../../models/AddPeople";
import AlertModal from "../../models/AlertModal";
import DesktopScreenShareModal from "../../models/DesktopScreenShareModal";
import { RemoveUserFromCall } from "../../Helpers/CallCommon";
import { _callDocUpdate, _updateCallParticipants } from "../../../SocketIo";
import CanvasUI from "../../customWhiteBoard/CanvasUI";
import Draggable from "react-draggable";
import { compareVersions, getRandomColor, isPlatform } from "../common";
import CallSidebar from "./callSidebar";
import { AddUserIcon } from "../../../assets/icons/svg";
import VideoToolbar from "./videoToolbar";
import InnerVideoSection from "./innerVideoSection";
import SharedFileData from "./sharedFileData";

let desktopSharingSources = null;
let onSourceChoose = null;
function setDesktopScreenShareSource(t, v) {
  desktopSharingSources = t;
  onSourceChoose = v;
  store.dispatch(setDesktopScreenShareShow(true));
}
let appVersion = "2.10.6";

const transport = getTransport();
const color = getRandomColor();

const VideoContainerHtml = (props) => {
  const nodeRef = useRef(null);
  const [kickOutAlert, setKickOutAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [userId, setUserId] = useState(null);
  const [pinUserId, setPinUserId] = useState(null);
  const [userHandRaise, setUserHandRaise] = useState(false);

  const [closeStage] = useState(false);
  const [screenWidth, setScreenWidth] = useState();
  const [screenHeight, setScreenHeight] = useState();
  const [currentPos, setCurrentPos] = useState({ x: 0, y: 0 });
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  });

  const [defaultPinedScreenId, setDefaultPinedScreenId] = useState("");
  const [sketchBoardIds, setSketchBoardIds] = useState(null);

  const { lib, call, chat, authUserDetail } = useSelector((state) => state);

  const {
    videoContainerVisible,
    isActiveCamera,
    isActiveSpeaker,
    isActiveMic,
    isActiveScreenSharing,
    isActiveRecording,
    desktopScreenShareShow,
    galleryViewParticipants,
    desktopVideoTrack: participantsDesktopVideoTrack,
    currentActiveVideoTracks,
    localDesktopVideoTrack,
    participantsScreenShared,
    activeSpeaker,
    isActivePenDraw,
    localVideoTrack,
    sharedScreenType,
  } = lib || {};

  const {
    addPeoplePopUp,
    allAttendeeList,
    callDetail,
    isOpenWhiteBoard,
    sharedFileData,
    electronAppVersion,
    currrentPage,
    hangupLoader,
    sketchBoardPosition,
  } = call || {};

  const { selectedLanguage } = chat || {};

  const { authSessionUser } = authUserDetail || {};

  const audioTracks = !isActiveSpeaker ? [] : getAudioTracks();

  const isLatestVersion = useMemo(() => {
    return electronAppVersion !== ""
      ? compareVersions(electronAppVersion, appVersion) !== -1
      : false;
  }, [electronAppVersion]);

  const handleDrag = (e, data) => {
    setCurrentPos({ x: data.x, y: data.y });

    const { leftBound, rightBound } = calculateBounds(screenWidth);

    setBounds({
      left: leftBound,
      top: -Math.round(screenHeight) + 100,
      right: rightBound,
      bottom: 0,
    });
  };

  const kickOutHandler = (user_id) => {
    const userName =
      allAttendeeList.find((filterItem) => filterItem.user_id === user_id)
        ?.name ?? "";
    setAlertMsg(`Are you sure you want to Kick Out ${userName} from Call ?`);
    setKickOutAlert(true);
    setUserId(user_id);
  };

  const addPeople = (e) => {
    e.preventDefault();
    e.stopPropagation();
    store.dispatch(setAddPeoplePopUp(!addPeoplePopUp));
  };

  const getUserIdFromParticipantId = (participantId) => {
    const room = GetRoom();
    let userId = "";
    const participantsDetail = room != null ? room.getParticipants() : {};
    const displayName =
      participantsDetail.length > 0
        ? participantsDetail?.find((findItem) => findItem._id === participantId)
            ?._displayName ?? null
        : null;
    let displayNameArrayData = null;
    if (displayName !== null) {
      displayNameArrayData = displayName?.split("_");
    }
    if (displayNameArrayData !== null) {
      userId = displayNameArrayData[1];
    }
    return userId;
  };

  const alertRemove = async () => {
    if (pinUserId !== null) {
      const getConvertedUserId = await getUserIdFromParticipantId(pinUserId);
      if (getConvertedUserId === userId) {
        setPinUserId(null);
      }
    }

    RemoveUserFromCall(userId, props.callDetails, allAttendeeList);
    setUserId(null);
    setKickOutAlert(false);
  };

  const toggleSketchBoard = async (event) => {
    event.preventDefault();
    if (isActivePenDraw) {
      // setCloseStage(true);
      transport.sendEvent({
        name: "toolbar-icons-update",
        type: "screenshare",
        value: false,
      });
      store.dispatch(setIsActivePenDraw(false));
    } else {
      const myUserId = authSessionUser.user_id;
      const userData = allAttendeeList.find(
        (filterItem) => filterItem.user_id === myUserId,
      );
      store.dispatch(setIsActivePenDraw(true));
      if (userData?.screenShareSource === "screen") {
        const platform = isPlatform();
        transport.sendEvent({
          name: "sketch-Board-clicked",
          type: "userDrawFullScreen",
          edit: true,
          color: color,
          platform,
        });
        // setCloseStage(false);
      } else {
        transport.sendEvent({
          name: "sketch-Board-clicked",
          type: "userDrawApp",
          edit: true,
          color: color,
        });
      }
    }
  };

  React.useEffect(() => {
    let drag_Width = (props?.width * window.innerWidth) / 100;
    const widthNumber = drag_Width / 4;
    setScreenWidth(widthNumber);
  }, [props?.width]);

  useEffect(() => {
    let drag_height = (props?.height * window.innerHeight) / 100;
    const heightNumber = drag_height;

    setScreenHeight(heightNumber);
  }, [props?.height]);

  useEffect(() => {
    if (props?.setInboundPinUser) {
      props?.setInboundPinUser(pinUserId);
    }
  }, [pinUserId]);

  useEffect(() => {
    if (props?.isDefaultScreen) {
      setCurrentPos({ x: 0, y: 0 });
    }
  }, [props?.isDefaultScreen]);

  useEffect(() => {
    if (isActiveScreenSharing) {
      transport.sendEvent({
        name: "toolbar-icons-update",
        type: "audio",
        value: isActiveMic,
      });
    }
  }, [isActiveMic, isActiveScreenSharing]);

  useEffect(() => {
    if (isActiveScreenSharing) {
      transport.sendEvent({
        name: "toolbar-icons-update",
        type: "video",
        value: isActiveCamera,
      });
    }
  }, [isActiveCamera, isActiveScreenSharing]);

  useEffect(() => {
    if (!isActiveScreenSharing && isActivePenDraw) {
      transport.sendEvent({
        name: "toolbar-icons-update",
        type: "screenshare",
        value: isActiveScreenSharing,
      });
      store.dispatch(setIsActivePenDraw(false));
    }
  }, [isActiveScreenSharing, isActivePenDraw]);

  useEffect(() => {
    transport.on("event", (event) => {
      if (event.name === "send-toolbar-update-icon-request") {
        const iconData = event?.data[0]?.iconData ?? {};
        if (iconData?.type === "audio") {
          const isActiveMic = store.getState().lib.isActiveMic;
          if (iconData?.value === false && isActiveMic) {
            muteMic();
          } else if (iconData?.value === true && !isActiveMic) {
            localAudioTrackUnMute();
          }
          // eslint-disable-next-line no-dupe-else-if
        } else if (iconData?.type === "video") {
          const isActiveCamera = store.getState().lib.isActiveCamera;
          if (iconData?.value === false && isActiveCamera) {
            localVideoTrackMute();
          } else if (iconData?.value === true && !isActiveCamera) {
            localVideoTrackUnMute();
          }
        } else if (iconData?.type === "screenshare") {
          const isActiveScreenSharingValue =
            store.getState().lib.isActiveScreenSharing;

          if (iconData?.value === false && isActiveScreenSharingValue) {
            stopscreenshare();
          }
        } else if (iconData?.type === "penDraw") {
          const isActivePenDraw = store.getState().lib.isActivePenDraw;
          if (iconData?.value === false && isActivePenDraw) {
            store.dispatch(setIsActivePenDraw(false));
          }
        }
      }
    });
  }, []);

  useEffect(() => {
    ShowActiveSpeakerOnFirstPage();
  }, [activeSpeaker]);

  useEffect(() => {
    if (
      pinUserId !== "localscreen" &&
      pinUserId !== null &&
      pinUserId.includes("screen")
    ) {
      if (participantsDesktopVideoTrack.length > 0) {
        const isDesktopUserExist = participantsDesktopVideoTrack.some(
          (item) => {
            const tempPinUserId = `${item?.participantId}screen`;
            return tempPinUserId === pinUserId;
          },
        );
        if (!isDesktopUserExist) {
          setPinUserId(null);
        }
      } else {
        if (defaultPinedScreenId === null) {
          setPinUserId(null);
        } else if (
          participantsDesktopVideoTrack.length === 0 &&
          defaultPinedScreenId !== null
        ) {
          setDefaultPinedScreenId(null);
          setPinUserId(null);
        }
      }
    }
  }, [participantsDesktopVideoTrack]);

  useEffect(() => {
    if (participantsScreenShared.length > 0) {
      const currentSharing =
        participantsScreenShared[participantsScreenShared.length - 1];

      if (currentSharing) {
        const currentSharingDetails = props.callDetails?.participantID.find(
          (participant) => participant?.jid === currentSharing,
        );
        if (
          currentSharingDetails &&
          currentSharingDetails.id === props.user_unique_key
        ) {
          setPinUserId("localscreen");
        } else {
          setPinUserId(currentSharing + "screen");
        }
      } else {
        setPinUserId(null);
      }
    } else {
      setPinUserId(null);
    }
  }, [participantsScreenShared]);

  useEffect(() => {
    if (
      pinUserId === "localscreen" &&
      (localDesktopVideoTrack === null ||
        localDesktopVideoTrack?.muted === true)
    ) {
      setPinUserId(null);
    }
  }, [localDesktopVideoTrack]);

  useEffect(() => {
    if (
      localDesktopVideoTrack !== null ||
      localDesktopVideoTrack?.muted === false
    ) {
      const id = localDesktopVideoTrack.jitsiTrack.getSourceName();
      const userID = authSessionUser?.user_id;
      if (
        sketchBoardPosition[id] &&
        sketchBoardPosition[id]?.user_id !== userID
      ) {
        const positions = sketchBoardPosition[id]?.position;
        transport.sendEvent({
          name: "sketch-Board-clicked",
          type: "clientDraw",
          color: sketchBoardPosition[id].color,
          position: positions,
          clearBoard: sketchBoardPosition[id]?.clearBoard,
          sharedScreenType,
        });
      }
    }
  }, [sketchBoardPosition]);

  // useEffect(() => {
  //   if (props.callDetails.type === "schedule") {
  //     if (props.user_unique_key === props.callDetails.senderID) {
  //       store.dispatch(setvideoContainerVisible("inherit"));
  //       store.dispatch(setiframeLoading(false));
  //     }
  //   }
  // }, [props.callDetails]);

  useEffect(() => {
    if (pinUserId !== null) {
      requestPinParticipiantVideos(pinUserId);
    } else {
      requestCallParticipiantsVideos();
    }
  }, [
    currrentPage,
    callDetail?.participantID,
    participantsDesktopVideoTrack,
    localDesktopVideoTrack,
    pinUserId,
  ]);

  useEffect(() => {
    const requestTimer = setInterval(() => {
      setGalleryTracks(pinUserId, true);
    }, 1 * 60 * 1000); // 1 minute

    return () => {
      clearInterval(requestTimer);
    };
  }, [currentActiveVideoTracks, pinUserId]);

  useEffect(() => {
    setGalleryTracks(pinUserId);
  }, [
    currentActiveVideoTracks,
    localVideoTrack,
    localDesktopVideoTrack,
    pinUserId,
  ]);

  // dont remove this comment

  // const toggleWhiteBoard = async (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   const updatedCallObject = Object.assign({}, callDetail, {
  //     whiteBoard: callDetail && callDetail?.whiteBoard === true ? false : true,
  //   });
  //   await _callDocUpdate(updatedCallObject);
  // };

  ////////////////////////

  useEffect(() => {
    let isMounted = true;

    const runEffect = async () => {
      if (pinUserId !== null) {
        const getConvertedUserId = await getUserIdFromParticipantId(pinUserId);

        const { participantID } = props.callDetails;

        const pinUserCallDetail =
          participantID?.length > 0
            ? participantID.find(
                (findItem) => findItem.id === getConvertedUserId,
              )
            : {};

        if (
          pinUserCallDetail?.status === "ended" ||
          pinUserCallDetail?.status === "decline"
        ) {
          if (isMounted) setPinUserId(null);
        }
      }

      const { type, participantID } = props.callDetails;

      if (type === "private" && participantID?.length === 0) {
        if (userHandRaise !== props.callDetails.hand_raise) {
          if (isMounted) setUserHandRaise(props.callDetails.hand_raise);
        }
      } else {
        const handRaiseFlag =
          participantID?.find(
            (findItem) => findItem.id === props.user_unique_key,
          )?.hand_raise ?? false;

        if (userHandRaise !== handRaiseFlag) {
          if (isMounted) setUserHandRaise(handRaiseFlag);
        }
      }
    };

    runEffect();

    return () => {
      isMounted = false;
    };
  }, [props.callDetails, pinUserId, userHandRaise, props.user_unique_key]);

  useEffect(() => {
    if (isActiveRecording) {
      if (props.user_unique_key !== props?.callDetails?.recorderUserId) {
        let recorderUserId = [];
        if (
          props?.callDetails?.type === "group" ||
          (props?.callDetails?.type === "private" &&
            props?.callDetails?.user_added === true)
        ) {
          // eslint-disable-next-line no-unsafe-optional-chaining
          const { participantID } = props?.callDetails;
          participantID.forEach((item) => {
            if (item?.status === "accepted") {
              recorderUserId.push(item.id);
            }
          });
        } else {
          // eslint-disable-next-line no-unsafe-optional-chaining
          const { receiverID } = props?.callDetails;
          recorderUserId.push(receiverID);
        }

        store.dispatch(setRecordingConsentUserIds(recorderUserId));
      }
    } else {
      store.dispatch(setRecordingConsentUserIds([]));
    }
  }, [isActiveRecording]);

  useEffect(() => {
    if (callDetail?.sharedFile) {
      store.dispatch(setSharedFileData(callDetail?.sharedFile));
    }
  }, [callDetail?.sharedFile]);

  useEffect(() => {
    if (sharedFileData) {
      if (Object.keys(sharedFileData).length > 0) {
        const { fileType, fileUrl, play } = sharedFileData;
        if (fileType === "audio") {
          let audio = document.getElementById("audioPlayer");
          let audioSource = document.createElement("source");
          audioSource.setAttribute("src", fileUrl);
          audio.appendChild(audioSource);
          if (play) {
            audio.play();
          } else {
            audio.pause();
          }

          audio.onended = () => {
            store.dispatch(setSharedFileData({}));
          };
        } else {
          let video = document.getElementById("videoPlayer");
          let videoSource = document.createElement("source");
          videoSource.setAttribute("src", fileUrl);
          video.appendChild(videoSource);
          if (play) {
            video.play();
          } else {
            video.pause();
          }
          video.onended = () => {
            store.dispatch(setSharedFileData({}));
          };
        }
      }
    }
  }, [sharedFileData]);

  useEffect(
    () => () => {
      transport.sendEvent({
        name: "sketch-Board-clicked",
        type: "userDrawFullScreen",
        edit: false,
        color: color,
      });
      transport.sendEvent({
        name: "sketch-Board-clicked",
        type: "userDrawApp",
        edit: false,
        color: color,
      });
      transport.sendEvent({
        name: "sketch-Board-clicked",
        type: "clientDrawResetBoard",
      });
    },

    [],
  );

  const handleGalleryView = (e) => {
    e.preventDefault();
    setPinUserId(null);
    setSketchBoardIds(null);
  };

  // useEffect(() => {
  //   if (props?.callDetails?.entireScreenSharedIds && !props?.callDetails?.entireScreenSharedIds.includes(sketchBoardIds)) {
  //     setSketchBoardIds(null);
  //   }
  // }, [props?.callDetails?.entireScreenSharedIds])

  useEffect(() => {
    if (pinUserId !== null && pinUserId !== sketchBoardIds) {
      setSketchBoardIds(null);
    }
  }, [pinUserId]);

  return (
    <>
      <div
        className={`video__wrapper d-flex justify-content-center ${
          isOpenWhiteBoard === true ? "white-board-style" : ""
        }`}
      >
        <div
          className="video__container d-flex justify-content-center flex-wrap position-relative"
          style={{ visibility: videoContainerVisible }}
        >
          {Object.keys(sharedFileData).length > 0 && <SharedFileData />}

          {Object.keys(sharedFileData).length > 0 &&
          sharedFileData?.fileType === "video" ? null : (
            <InnerVideoSection
              {...{
                props,
                kickOutHandler,
                pinUserId,
                setPinUserId,
                raiseHand,
                localDesktopVideoTrack,
                activeSpeaker,
                authSessionUser,
                allAttendeeList,
                sketchBoardIds,
                setSketchBoardIds,
                closeStage,
                // localVideoTrack,
                isLatestVersion,
                galleryViewParticipants,
                currentActiveVideoTracks,
                hangupLoader,
                selectedLanguage,
                // sharedScreenType,
              }}
            />
          )}

          {(props?.callDetails?.monitor_status === undefined ||
            props?.callDetails?.monitor_status === false) &&
          props.user_unique_key === props?.callDetails?.senderID ? (
            <div className="icon__container position-absolute top-left d-flex justify-content-between index-1 w-100 p-3">
              <div className="d-flex">
                <div
                  className={`position-relative d-flex ${
                    hangupLoader ? "btn-disabled" : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="icon__tag icon-add bg-white d-flex align-items-center justify-content-center icon_container index-3 mr-2"
                    onClick={addPeople}
                  >
                    <AddUserIcon />
                  </Link>
                  {/* <Link
                  to="#"
                  className="icon__tag bg-white d-flex align-items-center justify-content-center icon_container index-3"
                  onClick={openWhiteBoard}
                >
                  <svg viewBox="2 3 20 18.6" width={20} height={20}>
                    <path
                      fill="#b8c0c9"
                      d="M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 16V5h16l.001 11H4z"
                    ></path>
                    <path fill="#b8c0c9" d="M6 12h4v2H6z"></path>
                  </svg>
                </Link> */}

                  {addPeoplePopUp && (
                    <AddPeople
                      show={addPeoplePopUp}
                      handleClose={() =>
                        store.dispatch(setAddPeoplePopUp(false))
                      }
                      allAttendeeList={allAttendeeList}
                      callDetails={props.callDetails}
                      selectedLanguage={selectedLanguage}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <Draggable
          onDrag={handleDrag}
          bounds={bounds}
          position={currentPos}
          nodeRef={nodeRef}
        >
          <div className="video__toolbar" ref={nodeRef}>
            <VideoToolbar
              parentProps={props}
              {...{
                userHandRaise,
                raiseHand,
                toggleScreenShare,
                isLatestVersion,
                toggleSketchBoard,
                pinUserId,
                handleGalleryView,
              }}
            />
          </div>
        </Draggable>
        {isOpenWhiteBoard && <CanvasUI />}
      </div>

      {pinUserId != null && (
        <CallSidebar raiseHand={raiseHand} activeSpeaker={activeSpeaker} />
      )}

      {kickOutAlert && (
        <AlertModal
          show={kickOutAlert}
          closeModal={() => setKickOutAlert(false)}
          msg={alertMsg}
          Remove={alertRemove}
          alertType="kickOut"
          selectedLanguage={selectedLanguage}
        />
      )}

      {desktopScreenShareShow && (
        <DesktopScreenShareModal
          show={desktopScreenShareShow}
          handleClose={() => store.dispatch(setDesktopScreenShareShow(false))}
          desktopSharingSources={desktopSharingSources}
          onSourceChoose={onSourceChoose}
        />
      )}

      <div>
        {audioTracks?.map((t) => {
          return getAudioElement(t.jitsiTrack);
        })}
      </div>
    </>
  );
};

const raiseHand = (e, props, userId, handRaiseValue) => {
  e.preventDefault();
  const updatedCallDetail = { ...props.callDetails };
  const { participantID, type } = updatedCallDetail;
  if (type === "private" && participantID.length === 0) {
    updatedCallDetail["hand_raise"] = handRaiseValue;
    if (handRaiseValue) {
      let currenttimeUTC = new Date().toISOString();
      let timeStampUTC = Date.parse(currenttimeUTC);

      updatedCallDetail["hand_raised_timestamp"] = timeStampUTC;
    }
    _callDocUpdate(updatedCallDetail);
  } else {
    const updatedParticipantID = [...participantID];
    let index = participantID.findIndex((v) => v.id === userId);

    const particularObject = { ...updatedParticipantID[index] };
    particularObject.hand_raise = handRaiseValue;
    if (handRaiseValue) {
      let currenttimeUTC = new Date().toISOString();
      let timeStampUTC = Date.parse(currenttimeUTC);
      particularObject["hand_raised_timestamp"] = timeStampUTC;
    }
    const callParticipantsPayload = {
      company_id: updatedCallDetail?.company_id,
      id: updatedCallDetail?.id,
      participantID: particularObject,
      receiverID: updatedCallDetail?.receiverID,
    };

    _updateCallParticipants(callParticipantsPayload, "videocontainer-1925");
  }
};

const toggleScreenShare = async (event) => {
  event.preventDefault();
  const isActiveScreenSharing = store.getState().lib.isActiveScreenSharing;
  if (!isActiveScreenSharing) {
    window.JitsiMeetScreenObtainer = {
      openDesktopPicker(options, onSourceChoose) {
        showDesktopPickerConference(options, onSourceChoose);
      },
    };
    startscreenshare();
  } else if (isActiveScreenSharing) {
    stopscreenshare();
  }
};

function showDesktopPickerConference(options, onSourceChoose) {
  const { desktopSharingSources } = options;
  setDesktopScreenShareSource(desktopSharingSources, onSourceChoose);
}

export default VideoContainerHtml;
